"use client";

import { ScrollRevealText } from "@/components/ui/scroll-reveal-text";

/** Single-tone customer quote reveal — full quote in grey-950, wrapping naturally. */
export function CustomerQuoteReveal({
  quoteLead,
  quoteTrail,
}: {
  quoteLead: string;
  quoteTrail: string;
}) {
  return (
    <ScrollRevealText variant="light" as="span" className="text-balance">
      {quoteLead.trimEnd()} {quoteTrail}
    </ScrollRevealText>
  );
}
